var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdsButton',_vm._g(_vm._b({staticClass:"ml-3",attrs:{"loading":_vm.$store.state.isLoading,"icon":"mdi-content-save-outline","button-text":"Save and Publish"}},'AdsButton',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }